import React from "react"

import { Panel } from "primereact/panel"
import { Checkbox } from "primereact/checkbox"
import { Ripple } from "primereact/ripple"

import "../index.css"


const DispatchNote = (props) => {
    let { dispatchNote, selectedInvoiceDispatchNotesIds, selectedInvoiceDispatchNotes, dispatchNoteItems, selectedBuyerPOs, groupBuyerInvoiceItemsBy } = props

    const handleDeleteDispatchNote = () => {
        if(window.confirm("Confirm to delete dispatch note and delivery challan")){
            props.handleDeleteDispatchNote(dispatchNote.dispatchNoteId)
        }
    }

    const dispatchNoteTemplate = (options) => {
        const toggleIcon = !options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-right';
        const className = `${options.className} justify-content-between`;

        const relatedBuyerPO = selectedBuyerPOs.find(eachBuyerPO => eachBuyerPO.buyerPOId === dispatchNoteItems[0].buyerPOId)

        let selectedGroupByItemsOption = ""
        if(selectedInvoiceDispatchNotes.length){
            selectedGroupByItemsOption = selectedInvoiceDispatchNotes[0].itemsGroupedBy
            if(!selectedInvoiceDispatchNotes[0].itemsGroupedBy){
                selectedGroupByItemsOption = "buyerReqItemId"
            }
        }

        let isCheckboxDisabled = false
        if(props.isReplaceItems){
            isCheckboxDisabled = true
        }
        if(selectedGroupByItemsOption){
            let currentItemsGroupedBy = dispatchNote.itemsGroupedBy
            if(!currentItemsGroupedBy){
                currentItemsGroupedBy = "buyerReqItemId"
            }
            if(selectedGroupByItemsOption !== currentItemsGroupedBy){
                isCheckboxDisabled = true
            }
        }
        
        return (
            <div className={className} style={{ display: "flex", padding: "3px 10px", justifyContent: "", fontFamily: "Amazon Ember,Arial,sans-serif" }}>
                <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                    <span className={toggleIcon}></span>
                    <Ripple />
                </button>
                <div className="flex flex-row justify-content-start ml-3" style={{ flex: 1, justifyContent: "flex-start", alignItems: "center" }}>
                    <Checkbox
                        inputId={dispatchNote?.dispatchNoteId}
                        checked={selectedInvoiceDispatchNotesIds.includes(dispatchNote?.dispatchNoteId)}
                        onChange={() => groupBuyerInvoiceItemsBy === "buyerPOItemId" ? props.handleSelectDispatchCheckBoxBuyerPOItemLevel(dispatchNote.dispatchNoteId) : props.handleSelectDispatchCheckBox(dispatchNote?.dispatchNoteId)}
                        disabled={isCheckboxDisabled}
                    />
                    <div className="flex flex-column ml-3">
                        <p className="m-0">DN: <span style={{ fontWeight: 600 }}>{dispatchNote.docNo}</span></p>
                    </div>
                    { dispatchNote.deliveryChallan ? <div className="flex flex-column ml-3">
                        <p className="m-0">DC: <span style={{ fontWeight: 600, cursor: "pointer" }} onClick={() => window.open(`/delivery_challan/${dispatchNote.deliveryChallan.deliveryChallanId}`)}>{dispatchNote.deliveryChallan.docNo} <i className="pi pi-external-link doc-copy-icon"></i></span></p>
                    </div> : null}
                    { relatedBuyerPO ? <div className="flex flex-column ml-3">
                        <p className="m-0">Client PO Num: <span style={{ fontWeight: 600 }}>{relatedBuyerPO.clientPONum}</span></p>
                    </div> : null}
                    { relatedBuyerPO ? <div className="flex flex-column ml-3">
                        <p className="m-0">PO No: <span style={{ fontWeight: 600 }}>{relatedBuyerPO.docNo}</span></p>
                    </div> : null}
                </div>
                {/*<button className={options.togglerClassName} onClick={handleDeleteDispatchNote}>
                    <span className="pi pi-trash"></span>
                    <Ripple />
                </button>*/}
            </div>
        )
    }
    
    return (
        <Panel className="mb-2" id={dispatchNote?.dispatchNoteId} style={{ padding: "0px" }} headerTemplate={dispatchNoteTemplate} toggleable>
            <div className="dispatch-note-list">
                <table className="custom-table" style={{ width: "100%" }}>
                    <thead >
                        <tr className="custom-table-tr">
                            <th className="custom-th" style={{ width: "5%" }}>SR</th>
                            <th className="custom-th" style={{ width: "10%" }}>MATERIALID</th>
                            <th className="custom-th" style={{ width: "35%" }}>PRODUCT</th>
                            <th className="custom-th" style={{ width: "45%" }}>SPECIFICATION</th>
                            <th className="custom-th" style={{ width: "15%" }}>UOM</th>
                            <th className="custom-th"style={{ width: "10%" }} >QUANTITY</th>
                        </tr>
                    </thead>
                    <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        {
                            dispatchNoteItems?.map((eachDispatchItem, index) => {
                                let productName = eachDispatchItem.companyProdName ? eachDispatchItem.companyProdName : eachDispatchItem.productName
                                let productSpecification = eachDispatchItem.companyProdSpec ? eachDispatchItem.companyProdSpec : eachDispatchItem.productSpecification
                                
                                return (
                                    <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                        <td className="custom-td">{index + 1}</td>
                                        <td className="custom-td">{eachDispatchItem.materialId}</td>
                                        <td className="custom-td">{productName}</td>
                                        <td className="custom-td">{productSpecification}</td>
                                        <td className="custom-td">{eachDispatchItem?.UOM}</td>
                                        <td className="custom-td">{eachDispatchItem?.qty}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </Panel>
    )
}

export default DispatchNote